import { css } from 'styled-components'

import { fontFamily, fontSize, fontWeight } from '@bufferapp/ui/style/fonts'

/**
 *
 */

export const baseFont = css`
  font-family: ${fontFamily};
  font-size: ${fontSize};
  font-weight: ${fontWeight};
`
